import React, { Component } from "react";
import { PageHeader, Row, Empty, Pagination, Spin } from "antd";
import { SettingOutlined, SearchOutlined, RetweetOutlined } from "@ant-design/icons";
import axios from "axios";
import { connect } from "react-redux";
import { ButtonItem, SelectInsumosItem, InputItem, SegmentedItem } from "../../../../Components/Items";
import BotonAyudaManuales from "../../../../Components/BotonAyudaManuales";
import TarjetaOrdenProduccionPU from "./TarjetaOrdenProduccionPU";
import ModalOrdenRetrabajoPU from "./ModalOrdenRetrabajoPU";
import PlaneacionProduccionPU from "./PlaneacionProduccionPU/PlaneacionProduccionPU";
import { estiloBarraFiltros } from "./PlaneacionProduccionPU/planeacion.utils";

class OrdenesDeProduccionPU extends Component {
  timeoutBusqueda = null;
  state = {
    loading: false,
    ordenes: [],
    totalRecords: 0,
    page: 1,
    pageSize: 20,
    textoFiltro: "",
    insumoId: undefined,
    vista: "pendientes",
    modo: "planeacion",
    modalRetrabajoVisible: false,
    versionPlaneacion: 0,
  };

  componentDidMount() {
    if (this.state.modo === "listado") this.consultarOrdenes();
  }

  onChangeModo = (modo) => this.setState({ modo }, () => modo === "listado" && this.consultarOrdenes());

  consultarOrdenes = () => {
    const { page, pageSize, textoFiltro, insumoId, vista } = this.state;
    this.setState({ loading: true });
    axios
      .post(
        "ordenesDeProduccionPU/selectTodasOrdenes",
        { empresaId: this.props.empresaId, page, pageSize, textoFiltro, insumoId, vista, sortField: "createdAt", sortOrder: "descend" },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({ ordenes: res.data.data || [], totalRecords: res.data.totalRecords || 0 });
        }
      })
      .catch(() => this.setState({ loading: false }));
  };

  onChangePagina = (page, pageSize) => this.setState({ page, pageSize }, this.consultarOrdenes);

  onChangeTexto = (e) => {
    const textoFiltro = e.target.value;
    this.setState({ textoFiltro, page: 1 });
    clearTimeout(this.timeoutBusqueda);
    this.timeoutBusqueda = setTimeout(this.consultarOrdenes, 400);
  };

  onChangeInsumoFiltro = (insumoId) => this.setState({ insumoId, page: 1 }, this.consultarOrdenes);

  onChangeVista = (vista) => this.setState({ vista, page: 1 }, this.consultarOrdenes);

  irAConfiguracion = () => this.props.history.push("/panel/configuracionOrdenesDeProduccionPU");

  irAEtapas = (ordenId, mover) => this.props.history.push("/panel/verOrdenDeProduccionPU", { id: ordenId, mover });

  verOrden = (ordenId) => this.props.history.push("/panel/ordenDeProduccionPU", { ordenId, soloLectura: true });

  editarOrden = (ordenId) => this.props.history.push("/panel/ordenDeProduccionPU", { ordenId, soloLectura: false });

  renderFiltrosListado() {
    return (
      <div style={estiloBarraFiltros}>
        <SegmentedItem
          options={[
            { label: "Pendientes", value: "pendientes" },
            { label: "Terminadas", value: "terminadas" },
            { label: "Todas", value: "todas" },
          ]}
          value={this.state.vista}
          onChange={this.onChangeVista}
        />
        <div style={{ flex: 1 }} />
        <InputItem
          prefix={<SearchOutlined />}
          placeholder="Buscar por folio..."
          style={{ width: 220 }}
          value={this.state.textoFiltro}
          onChange={this.onChangeTexto}
        />
        <SelectInsumosItem
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          placeholder="Buscar por insumo usado..."
          style={{ width: 280 }}
          allowClear
          value={this.state.insumoId}
          onChange={this.onChangeInsumoFiltro}
        />
      </div>
    );
  }

  renderListado() {
    const { ordenes, loading, totalRecords, page, pageSize } = this.state;
    return (
      <>
      {this.renderFiltrosListado()}
      <div style={{ backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)" }}>
        <Spin spinning={loading}>
          {ordenes.length === 0 ? (
            <Empty description='Todavía no se ha generado ninguna orden -- créala desde el botón en una partida de un Presupuesto PU' />
          ) : (
            <>
              <Row gutter={[12, 12]}>
                {ordenes.map((orden) => (
                  <TarjetaOrdenProduccionPU
                    key={orden._id}
                    orden={orden}
                    onVer={this.verOrden}
                    onEditar={this.editarOrden}
                    onVerEtapas={this.irAEtapas}
                    permisoEditar={this.props.permisoEditarOrdenProduccionPU}
                    permisoMoverPiezas={this.props.permisoMoverPiezasOrdenProduccionPU}
                  />
                ))}
              </Row>
              <Row justify="end" style={{ marginTop: 16 }}>
                <Pagination
                  current={page}
                  pageSize={pageSize}
                  total={totalRecords}
                  showSizeChanger
                  pageSizeOptions={["12", "20", "40", "60"]}
                  onChange={this.onChangePagina}
                  onShowSizeChange={this.onChangePagina}
                />
              </Row>
            </>
          )}
        </Spin>
      </div>
      </>
    );
  }

  render() {
    const esListado = this.state.modo === "listado";

    return (
      <>
        <PageHeader
          title="Órdenes de Producción"
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={[
            <SegmentedItem
              key="modo"
              options={[
                { label: "Planeación", value: "planeacion" },
                { label: "Listado", value: "listado" },
              ]}
              value={this.state.modo}
              onChange={this.onChangeModo}
            />,
            this.props.permisoAgregarOrdenProduccionPU && (
              <ButtonItem key="retrabajo" lila botonAncho icon={<RetweetOutlined />} onClick={() => this.setState({ modalRetrabajoVisible: true })}>
                Orden de retrabajo
              </ButtonItem>
            ),
            this.props.permisoConfigurarCampos && (
              <ButtonItem key="config" botonAncho gris icon={<SettingOutlined />} onClick={this.irAConfiguracion}/>
            ),
            <BotonAyudaManuales key="manuales" modulo="ordenesProduccionPU" />,
          ]}
        />

        {esListado ? (
          this.renderListado()
        ) : (
          <PlaneacionProduccionPU
            key={this.state.versionPlaneacion}
            onVer={this.verOrden}
            onVerEtapas={this.irAEtapas}
            permisoMoverPiezas={this.props.permisoMoverPiezasOrdenProduccionPU}
            permisoEditar={this.props.permisoEditarOrdenProduccionPU}
          />
        )}
        <ModalOrdenRetrabajoPU
          visible={this.state.modalRetrabajoVisible}
          onCerrar={() => this.setState({ modalRetrabajoVisible: false })}
          onCreada={() =>
            this.setState((prev) => ({ modalRetrabajoVisible: false, versionPlaneacion: prev.versionPlaneacion + 1 }), () => this.state.modo === "listado" && this.consultarOrdenes())
          }
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  permisoConfigurarCampos:
    state.user.tipo === 0 ||
    !!state.user.permisos.find((v) => v.permisoId.toString() === "6a9b30eae58adfd453df660e")?.activado,
  permisoEditarOrdenProduccionPU:
    state.user.tipo === 0 ||
    !!state.user.permisos.find((v) => v.permisoId.toString() === "6a9b3041e58adfd453df65bf")?.activado,
  permisoAgregarOrdenProduccionPU:
    state.user.tipo === 0 ||
    !!state.user.permisos.find((v) => v.permisoId.toString() === "6a9b303352b97b73c85edc24")?.activado,
  permisoMoverPiezasOrdenProduccionPU:
    state.user.tipo === 0 ||
    !!state.user.permisos.find((v) => v.permisoId.toString() === "6a9b305e52b97b73c85edd94")?.activado,
});

export default connect(mapStateToProps)(OrdenesDeProduccionPU);
